import { AfterViewInit, Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { GlobalCfgFactory } from '@shared/factories/global-cfg/global-cfg.factory';
import { LoaderFactory } from '@shared/factories/loader/loader.factory';
import { AfTranslateFactory } from '@shared/modules/translate/factory/translate.factory';
import { ApiServiceService } from '@shared/services/api-service/api-service.service';
import { CommonUtilsService } from '@shared/services/common-utils/common-utils.service';
import { ModalServiceService } from '@shared/services/modal-service/modal-service.service';
import { cloneDeep } from 'lodash';
import ExpandMenu from '../../../../assets/data/expanded-menu.json'
import { DocumentActionsService } from '@shared/services/document-actions/document-actions.service';
import { ExtensionDocumentPipe } from '../../filters/extension-document/extension-document.pipe';
import { ConvertDatePipe } from '../../filters/convert-date/convert-date.pipe';
import { AfTranslatePipe } from '@shared/modules/translate/pipe/af-translate.pipe';
import { AfOrderByPipe } from '@shared/filters/af-order-by/af-order-by.pipe';
import { AfTranslateDirective } from '../../modules/translate/directive/af-translate.directive';
import { FilterByOrderComponent } from "../filter-by-order/filter-by-order.component";
import { FilterBySearchAndOrderComponent } from "../filter-by-search-and-order/filter-by-search-and-order.component";
import { FilterByListAndOrderComponent } from "../filter-by-list-and-order/filter-by-list-and-order.component";
import { FilterColumnService } from '@shared/services/filter-column/filter-column.service';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { SpanTooltipComponent } from "../span-tooltip/span-tooltip.component";
import { ButtonWithMenuActionComponent } from "../button-with-menu-action/button-with-menu-action.component";
import { ExpandedMenuService } from '@shared/services/expanded-menu/expanded-menu.service';
import { RegisterMixtapeService } from '@shared/services/register-mixpanel/register-mixtape.service';

@Component({
  selector: 'associated-documentation',
  templateUrl: './associated-documentation.component.html',
  standalone: true,
  imports: [
    AfTranslateDirective,
    AfOrderByPipe,
    AfTranslatePipe,
    ConvertDatePipe,
    ExtensionDocumentPipe,
    FilterByOrderComponent,
    FilterBySearchAndOrderComponent,
    FilterByListAndOrderComponent,
    ProgressSpinnerModule,
    SpanTooltipComponent,
    ButtonWithMenuActionComponent
  ]
})
export class AssociatedDocumentationComponent implements OnInit, AfterViewInit {
  skin: string = this.globalCfg.skin;
  expandMenu:any = ExpandMenu;
  process: any = this.dialogConfig.data.process;
  concept: any = this.dialogConfig.data.concept;
  listSelect: any = this.dialogConfig.data.listSelect;
  from: any = this.dialogConfig.data.from;
  document: any = this.dialogConfig.data.document;
  associatedDocument: any = {
    showChangeAssociated: false,
    orderCreation: false,
    previewAssociated: false,
    desassociateDocument: false,
    disabledSave: false,
    searchingDocuments: false,
    order: 'name',
    nameState: '',
    statesChanged: [],
    documentationList: [],
    documentSelected:{},
    processSteps: {
        label: this.translate.instant('common.associated-documentation-to-process')
    },
    acceptButton: this.translate.instant('common.associate'),
    titleHeader: this.translate.instant('associated-documentation.associated-documentation'),
    iconHeader: "lf-icon-documentation",
    stateId: null,
    nameFilter: {
      name: this.translate.instant('common.title'),
      filterOrder: 'name'
    },
    createdFilter: {
      name: this.translate.instant('common.creation'),
      filterOrder: 'created'
    },
    menuDocumentViewEdit: this.expandMenu['menuDocumentViewEdit'].menu,
    extensionFilter: { name: this.translate.instant('common.type') },
    createdByFilter: { name: this.translate.instant('common.author') },
    filters:[ 'extension', 'createdBy'],
    filterDocumentationList:[],
    positionAction:'0px'
  }

  constructor(private globalCfg: GlobalCfgFactory,
    private commonUtilsService: CommonUtilsService,
    private translate: AfTranslateFactory,
    private apiService: ApiServiceService,
    private loader: LoaderFactory,
    private modalService: ModalServiceService,
    private documentActions: DocumentActionsService,
    private dialogRef: DynamicDialogRef<AssociatedDocumentationComponent>,
    private dialogConfig: DynamicDialogConfig,
    private filterColumnService: FilterColumnService,
    private expandedMenuService: ExpandedMenuService,
    private registerService: RegisterMixtapeService) { }

  ngOnInit(): void {
    this.configureDocumentation();
  }

  ngAfterViewInit(): void {
    this.getPositionAction()
  }

  configureDocumentation(){
    this.associatedDocument.listSelectShow = cloneDeep(this.listSelect);
    if(this.process?.stateId && this.from === 'process-modal'){
        //this.associatedDocument.listSelectShow = this.commonUtilsService.deleteElement(this.process, this.associatedDocument.listSelectShow, 'stateId')
        this.associatedDocument.expandedMenu = this.expandMenu['menuAssociatedDocument'].menu;
        this.getDocumentOfState();
    }else if(this.from === 'documentation'){
        this.associatedDocument.titleHeader = this.translate.instant('associated-documentation.association-process');
        this.associatedDocument.acceptButton = this.translate.instant('common.save');
        this.associatedDocument.showChangeAssociated = true;
        this.associatedDocument.iconHeader = "lf-icon-process";
        this.associatedDocument.documentSelected = this.document;
        this.associatedDocument.disabledSave = true;
        if(this.process && this.process.stateId){
          this.associatedDocument.stateId = this.process.stateId;
          this.associatedDocument.previewAssociated = true;
        }
    }

  }

  getDocumentOfState(){
    this.associatedDocument.searchingDocuments = true;
    this.apiService.get('documentobjects/'+this.concept.conceptObjectId+'/state/'+this.process.stateId)
        .then((data:any)=>{
          this.associatedDocument.documentationList = data.documents;
            this.getListDocument(data);
        },(errorData:any)=>{
          this.associatedDocument.searchingDocuments = false;
        })
  }

  getListDocument(listDocument:any){
    for (let subFolder of listDocument.subFolders) {
        if(subFolder.documents.length){
          this.associatedDocument.documentationList = this.associatedDocument.documentationList.concat(subFolder.documents);
        }
        if(subFolder.subFolders.length){
            this.getListDocument(subFolder);
        }
    }

    this.getFilters();

  }

  getFilters(){
    let associatedDocument:any = this.associatedDocument;
      associatedDocument.filters.forEach((filter:any)=>{
        associatedDocument[filter+'List'] = this.filterColumnService.extractList(filter,  associatedDocument.documentationList);
        associatedDocument[filter+'ListFilter'] = [];
      })
      this.filterDocumentation();
  }

  filterDocumentation(){
    let filterList:any = this.associatedDocument.documentationList;
    this.associatedDocument.filters.forEach((filter:any) => {
      let filteredList:any = this.associatedDocument[filter+'ListFilter'];
      filterList = this.filterColumnService.filterBycolumn(filterList, filteredList, filter);
    });
    this.associatedDocument.filterDocumentationList = filterList;
    this.associatedDocument.searchingDocuments = false;
  }

  getPositionAction(){
    let documentationListTableContainer: any = document.getElementById('associated-documentation');
    this.associatedDocument.positionAction = documentationListTableContainer.offsetWidth+documentationListTableContainer.scrollLeft-38+'px';
  }

  launchAction(action:any, document:any){
    switch(action){
      case 'view':
        this.document = document;
        // this.associatedDocument.action = 'open';
        this.documentActions.doAction({action: 'open', file: document});
        break;
      case 'download':
        this.document = document;
        // this.associatedDocument.action = 'download';
        this.documentActions.doAction({action: 'download', file: document});
        break;
      case 'duplicate':
        this.registerEvent('duplicate document', document);
        this.duplicateDocumentSelected(document);
        break;
      case 'rename':
        this.openChangeNameDocument(document);
        break;
      case 'change':
        let configuration:any = {
          document: document,
          processSteps: this.associatedDocument.processSteps,
          listSelectShow: this.associatedDocument.listSelectShow,
          stateId: document.state.stateId,
          title:  this.translate.instant('expanded-menu.change-association'),
        }
        this.modalService.changeAssociation(configuration)
          .subscribe((result:any)=>{
            if(result.result === 'change-state'){
              this.selectProcess(result.processSelect);
                this.openInfoModal(this.translate.instant('change-association.change-state-success'));

            }
          })
        break;
      case 'unlink':
        this.associatedDocument.documentSelected = document;
        this.loader.openLoader('associate-document-change');
        this.associateDocument('documentobjects/'+ document.documentObjectId + '/state/'+ 0);
        break;
      default:
        break;
    }
  }

   registerEvent(type:any, documentSelected:any, source:any = null){
    let resgisterItem:any ={
      event: type,
      conceptName: sessionStorage.getItem('breadcrumbConcept') + this.concept.title,
      source: source && source !== null? source : documentSelected.sourceName,
      template: documentSelected.source === 'Template'?'1':'0',

    }
    this.registerService.register(resgisterItem);
  }

  duplicateDocumentSelected(document:any){
    let configuration:any = {
      title:  this.translate.instant('common.duplicate'),
      type: 'duplicate',
      previousTitle: document.name,
      list: this.associatedDocument.documentationList
    }
    this.modalService.renameModal(configuration)
      .subscribe((result:any)=>{
        if(result.result==='ok'){
          this.loader.openLoader('documentation-list-duplicate-document');
          this.createDuplicateDocument(document, result.name);
        }
      })
  }

  createDuplicateDocument(document:any, name:any){
    this.apiService.add('documentObjects/duplicatedocument/'+document.documentObjectId, {name: name})
      .then((data:any)=> {
      this.associatedDocument.documentationList.push(data);
      this.filterDocumentation();
      this.loader.closeLoader(['documentation-list-duplicate-document']);
      this.modalService.successModal({ text: this.translate.instant('evaluation.duplicated-success') });
      }, (errorData:any)=>{
        this.loader.closeError();
        let text:string = this.translate.instant('documentation-list.error-duplicate-document').replace('{document}','');
        if(errorData && errorData.description && errorData.description.exceptionMessage && errorData.description.exceptionMessage==="File already exists"){
          text = this.translate.instant('documentation-list.document-name-exists-published').replace('{document}', name);
        }
        this.modalService.errorModal({ text: text });
      })
  }

   openChangeNameDocument(document:any){
    let lastPoint:any = document.name.lastIndexOf('.');

      if(lastPoint !== -1){
        this.associatedDocument.lastExtension = document.name.substring(lastPoint, document.name.length);
      }else{
        document.name + this.associatedDocument.lastExtension;
      }
    let configuration:any = {
      title:  this.translate.instant('documentation-list.rename-document'),
      type: 'associated-documentation',
      previousTitle: document.name,
      conceptId: null,
      conceptObjectId: document.conceptObjectId,
      list: this.associatedDocument.documentationList
    }
    this.modalService.renameModal(configuration).subscribe((result:any)=>{
      if(result.result ==='ok'){
        this.loader.openLoader('rename-modal');
        this.changeName(document, result.name);
      }
    })
  }

  changeName(document:any, name:any){
    let url: string = 'documentobjects';
    let id: any = document.documentObjectId;
    let newDocument:any = {
      name: name
    };
    this.apiService.patch(url, id, newDocument)
      .then((data:any)=>{
        document.name = name;
        let text: any = this.translate.instant('evaluation.change-name-ok');
        if(document.extension !=='folder'){
          document.name = name +'.'+ document.extension.toLowerCase();
          document.editPath = document.editPath.substring(0, document.editPath.lastIndexOf('/')+1) + newDocument.name +'.'+ document.extension.toLowerCase();
          text = this.translate.instant('documentation-list.rename-ok-message');
        }
        this.loader.closeLoader(['rename-modal']);
        this.modalService.successModal({ text: text });
      }, ()=>{
        this.loader.closeError();
        this.modalService.errorModal({ text: this.translate.instant('documentation-list.error-rename-document') })
      })
  }





  associateDocument(url:string){
    this.apiService.patch(url)
      .then((data:any)=>{
        this.loader.closeLoader(['associate-document-change']);
        if(this.from === 'process-modal'){
            let text = this.translate.instant('associated-documentation.message-change-associated');
            if(!this.associatedDocument.stateId){
                let textReplace = this.translate.instant('change-association.unlink-success');
                text = textReplace.replace('{titleStep}', this.process.name);
            }
            this.openInfoModal(text);
        }else{
            this.document.stateProcess = this.associatedDocument.nameState;
            this.document.state = {
                name: this.associatedDocument.nameState,
                stateId: this.associatedDocument.stateId
            }
            if(this.associatedDocument.desassociateDocument){
                this.document.stateProcess = '';
                this.document.state = null;
            }
            this.changeState(this.concept.documentation);
            this.handleAccept();
        }
    }, (errorData:any)=>{
        this.loader.closeError();
        this.modalService.errorModal({ text: this.translate.instant('process.modal.error-change-document') });
    });
}

  openInfoModal(text:any){
    let that: any = this.associatedDocument;
    this.modalService.successModal({ text: text })
      .subscribe((result:any)=>{
        that.showChangeAssociated = false;
        this.changeState(this.concept.documentation);
        if(that.stateId && that.statesChanged.indexOf(that.stateId) === -1 ){
            that.statesChanged.push(that.stateId);
        }
        that.stateId = null;
        that.documentationList = this.commonUtilsService.deleteElement(that.documentSelected, that.documentationList, 'documentObjectId')
      });
  }

  changeState(list:any){
    for (let [index,document] of list.documents.entries()) {

        if(this.associatedDocument.documentSelected.documentObjectId === document.documentObjectId){
            if(this.associatedDocument.desassociateDocument){
              list.documents[index].stateProcess = "";
              list.documents[index].state = null;
            }else{
              list.documents[index].stateProcess = this.associatedDocument.nameState;
              list.documents[index].state = {
                    name: this.associatedDocument.nameState,
                    stateId: this.associatedDocument.stateId
                }
            }
            break;
        }
        if(list.subFolder && list.subFolder.length){
            this.changeState(list);
        }
    }
  }

  selectProcess(newValue:any){
    this.associatedDocument.stateId = newValue;
    if(newValue){
        for(let item of this.listSelect){
            if(item.stateId === newValue){
                this.associatedDocument.nameState = item.name;
                break;
            }else{
              this.associatedDocument.nameState = '';
            }
        }
        this.associatedDocument.processSteps.error = false;
    }else{
      this.associatedDocument.nameState = '';
    }

    this.associatedDocument.disabledSave = (this.from === 'documentation' && ((!this.associatedDocument.stateId) || (this.associatedDocument.previewAssociated && this.process.stateId === this.associatedDocument.stateId)))
}

filterOrder(ev:any, type: string = ''){
  if(this.associatedDocument.order === type){
      this.associatedDocument.orderCreation = !this.associatedDocument.orderCreation;
  }else{
      this.associatedDocument.order = type;
      this.associatedDocument.orderCreation = type === 'name'
  }
}

openDocumentationMenu(instance:any){
  let optionMenu: any = {
    menuDocumentViewEdit: this.associatedDocument.menuDocumentViewEdit
  }
  instance.expandedMenu = this.expandedMenuService.conceptInstancesListAction(this.expandMenu['menuAssociatedDocument'].menu, instance, optionMenu);
  instance.openMenuAction = true;
}


  handleDismiss() {
    if(this.from === 'process-modal'){
        this.handleAccept();
    }else{
      this.dialogRef.close({result:'cancel'});
    }
  }

  handleAccept() {
    this.dialogRef.close({
        result : 'ok',
        statesChanged: this.associatedDocument.statesChanged,
        documents: this.associatedDocument.documentationList.length
    })

};

}

